import React, { useState } from 'react';
import FAQImage from '../assets/FAQ-Images.webp';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqs = [
        {
            question: "Where can I access the current packages offered by TX Hospitals?",
            answer: "All our health offers and health packages are advertised on our website",
        },
        {
            question: "How do I book an appointment for the package?",
            answer: "Please call on our Help Line number 9089489089 to book a package",
        },
        {
            question: "What healthcare packages does TXH offer?",
            answer: "We offer various type of Health packages Comprehensive Health Packages Cardiac Nephrological Gastroenterological Neurological Urology Specific Executive Health Check-Ups Age Specific Packages Gender Specific Packages",
        },
        {
            question: "How can I access the tariff list for admission and procedures of TXH?",
            answer: "You can call us and speak to our financial counseling team for any kind of assistance on the hospital tariffs 040 – 26108108 (Banjara Hills) 040 – 48108108 (Kachiguda) 040 – 43108108(Uppal)",
        },
        {
            question: "Do TX Hospitals offer health care education?",
            answer: "TX Hospitals intends to serve the society in more ways than one Apart from offering healthcare services we also have a healthcare education channel that offers health care education and tips on various diseases and conditions",
        },
    ];

    return (
        <div className="bg-gray-100 container mx-auto py-8">
            <h2 className="text-3xl text-red-700 font-bold text-center mb-6">FAQs</h2>
            <div className="flex h-auto">
                {/* Left Panel */}
                <div className="w-1/2 flex items-center justify-center bg-gray-100">
                    <img
                        src={FAQImage}
                        alt="FAQ Illustration"
                        className="max-w-full max-h-80 object-contain"
                    />
                </div>

                {/* Right Panel */}
                <div className="w-1/2 p-6 overflow-y-auto bg-white rounded-lg shadow-md mr-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="border-b border-gray-300 py-4 cursor-pointer"
                            onClick={() => toggleFAQ(index)}
                            onMouseEnter={() => toggleFAQ(index)}
                        >
                            <div className="flex items-center text-lg font-semibold">
                                <span className="w-6 text-xl text-center mr-2">
                                    {activeIndex === index ? '-' : '+'}
                                </span>
                                {faq.question}
                            </div>
                            <div
                                className={`overflow-hidden transition-[max-height] duration-500 ease-in-out ${
                                    activeIndex === index ? 'max-h-40 mt-2' : 'max-h-0'
                                }`}
                            >
                                <p className="text-gray-700">{faq.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQ;
